import { css } from '@linaria/core';

export const PopoverWrapper = css`
	top: 0;
	left: 0;
	width: max-content;
	padding: 14px 16px;
	border: none;
	border-radius: var(--radius-s);
	margin: 0 !important;
	backdrop-filter: blur(12px);
	background-color: var(--color-black-l);
	box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.35);
	opacity: 0;
	outline: none;
	transform: scale(0.7);

	--transition-time: 0.2s;

	&:popover-open {
		opacity: 1;
		transform: none;
		transition: opacity var(--transition-time),
			transform var(--transition-time) ease-in-out,
			display var(--transition-time) allow-discrete;

		@starting-style {
			opacity: 0;
			transform: scale(0.7);
		}
	}
`;
